/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_SchedulingInputs */

const en_messages_scheduling = /** @type {(inputs: Messages_SchedulingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduling…`)
};

const he_messages_scheduling = /** @type {(inputs: Messages_SchedulingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מתזמן…`)
};

/**
* | output |
* | --- |
* | "Scheduling…" |
*
* @param {Messages_SchedulingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_scheduling = /** @type {((inputs?: Messages_SchedulingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_SchedulingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_scheduling(inputs)
	return he_messages_scheduling(inputs)
});